var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveEvaluationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.794,
    height: 25.931,
    viewBox: "0 0 34.794 25.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58.009 0.628)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M213.194,91.005a3.425,3.425,0,1,1,0-4.839A3.433,3.433,0,0,1,213.194,91.005Zm0,0",
    transform: "translate(-135.36 -76.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M293.433,60.707a1.63,1.63,0,0,1-1.151-2.783,6.809,6.809,0,0,0,0-9.642,1.629,1.629,0,0,1,2.3-2.307,10.067,10.067,0,0,1,0,14.255,1.623,1.623,0,0,1-1.151.476Zm0,0",
    transform: "translate(-210.916 -40.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M328.386,24.805a1.629,1.629,0,0,1-1.151-2.783,13.582,13.582,0,0,0,0-19.237,1.629,1.629,0,0,1,2.3-2.307,16.843,16.843,0,0,1,0,23.85,1.625,1.625,0,0,1-1.151.476Zm0,0",
    transform: "translate(-242.183 -0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M137.511,60.706a1.625,1.625,0,0,1-1.151-.476,10.067,10.067,0,0,1,0-14.255,1.629,1.629,0,0,1,2.3,2.307,6.809,6.809,0,0,0,0,9.642,1.63,1.63,0,0,1-1.151,2.783Zm0,0",
    transform: "translate(-69.216 -40.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.666,24.8a1.623,1.623,0,0,1-1.151-.476,16.842,16.842,0,0,1,0-23.85,1.629,1.629,0,0,1,2.3,2.307,13.583,13.583,0,0,0,0,19.237A1.629,1.629,0,0,1,85.666,24.8Zm0,0",
    transform: "translate(-21.057 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveEvaluationIcon);
export default __webpack_public_path__ + "static/media/live-evaluation-icon.8c01fcfe9cc2847ad14b1615e3aab3ed.svg";
export { ForwardRef as ReactComponent };